import Box from "../Box";
const KeyboardAvoidingView = Box;
export default KeyboardAvoidingView;
